import React from "react";
import CountUp from 'react-countup';
import SectionTitle from "../section-title/SectionTitle";

const CounterItem = [
    {
        number: "500",
        title: "Clients Protected"
    },
    {
        number: "15",
        title: "Years Experience"
    },
    {
        number: "150",
        title: "Security Professionals"
    }
];

const AboutUs = () => {
    return (
        <>
            {/* About Start */}
            <div className="about-sec pt-100 pb-100">
                <div className="container">
                    <div className="row">
                        <div className="col-md-7">
                            <div className="about-desc">
                                <SectionTitle
                                title="<span>About</span> Iron Wall X"
                                content="<p>Iron Wall X is Turkey's premier security company, delivering comprehensive protection solutions across Istanbul, Ankara, and major cities nationwide. With over 15 years of experience, we have established ourselves as the trusted partner for businesses and individuals seeking world-class security services.</p><p>Our team of highly trained security professionals combines cutting-edge technology with proven methodologies to safeguard your assets, people, and operations. From corporate security to residential protection, CCTV surveillance to event management, we provide 24/7 security solutions tailored to your unique needs. Choose Iron Wall X for reliable, professional security you can trust.</p>"
                                />
                                <div className="about-countup">
                                    {
                                        CounterItem.map((data, i) => (
                                            <div key={i} className="counting-inner">
                                                <div className="countup-text">
                                                    <h2 className="counter"><CountUp end={data.number} duration={2.5} delay={0.9} start={0} /></h2>
                                                    <h4>{data.title}</h4>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-md-5">
                            <div className="about-us-img">
                                <img src={require('../../assets/images/about.png')} alt="About Thumb" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* About End */}
        </>
    );
}

export default AboutUs;